export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img4-9625118175aec56695b5446380701859.jpg";